module.exports = __webpack_public_path__ + "static/media/medellin-8.618c05da.jpg";